import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Modal from '@ublique/components/Modal'

import './index.scss'
import {
  DISABLE,
  DISABLE_SCENARIO,
  ENABLE,
  ENABLE_SCENARIO,
  ENABLING,
  HEADING
} from './constants'

function EnablingScenarioModal({ open, close, data }) {
  const { onSubmit, scenario } = data
  const { enabled } = scenario

  const { t: scheduledT } = useTranslation('ScheduledPlatform')

  const t = (label) => scheduledT(`EnablingModal.${label}`)

  const onEnable = useCallback(() => {
    onSubmit(scenario)
    close()
  }, [close, onSubmit, scenario])

  return (
    <Modal
      size='sm'
      className='enable-scenario-modal'
      open={open}
      onRequestClose={close}
      modalHeading={t(`${HEADING}`)}
      onRequestSubmit={onEnable}
      primaryButtonText={enabled ? t(`${DISABLE}`) : t(`${ENABLE}`)}
      secondaryButtonText={t('Common:Cancel')}
      confirmLoadingMessage={t(`${ENABLING}`)}
    >
      <h5>{enabled ? t(`${DISABLE_SCENARIO}`) : t(`${ENABLE_SCENARIO}`)}</h5>
    </Modal>
  )
}

export default EnablingScenarioModal
